module.exports = __webpack_public_path__ + "static/inc-graphic-898925f16f88fd70a7ea7d9c2bd99eeb.png";